module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/select-type/ja-JP/btn_select-text-title.png";